import React from 'react';
import Chip from '@mui/material/Chip';
import CheckCircle from '@mui/icons-material/CheckCircle';
import HourglassEmpty from '@mui/icons-material/HourglassEmpty';
import Autorenew from '@mui/icons-material/Autorenew';
import RateReview from '@mui/icons-material/RateReview';
import { PORTAL_JOB_STATUS_COLOR, PORTAL_JOB_STATUS_ICON } from './portalStatus';

const ICONS = {
  pending: <HourglassEmpty fontSize="small" />,
  progress: <Autorenew fontSize="small" />,
  review: <RateReview fontSize="small" />,
  done: <CheckCircle fontSize="small" />,
};

export const PortalStatusChip = ({ status, label }: { status: string; label: string }) => (
  <Chip
    size="small"
    icon={ICONS[PORTAL_JOB_STATUS_ICON[status] ?? 'pending']}
    label={label}
    color={PORTAL_JOB_STATUS_COLOR[status] ?? 'default'}
    variant={status === 'F' ? 'filled' : 'outlined'}
    sx={{ fontWeight: 600 }}
  />
);
